
export const enum RoadmapBaseEventFileTypes {
  pdf = 'pdf',
  rtf = 'rtf',
  docx = 'docx',
  xls = 'xls',
  xlsx = 'xlsx',
  odt = 'odt',
  jpeg = 'jpeg',
  rar = 'rar',
  '7z' = '7z',
  zip = 'zip',
}

export interface RoadmapBaseEvent {
  id: number;
  name: string;
  description: string;
  file_types: RoadmapBaseEventFileTypes[];
  max_file_size: number;
  max_file_count: number;
  created_at: string;
  updated_at: string;
}

export interface RoadmapBaseEventCollection extends RoadmapBaseEvent {
}
